import { jsx } from 'react/jsx-runtime';
import { Primitive } from '@radix-ui/react-primitive';
import classNames from 'classnames';
import { forwardRef } from 'react';
import { footerStyle } from '../dialog.vanilla.mjs';

const Footer = forwardRef(
  ({ className, orientation, ...props }, ref) => {
    return /* @__PURE__ */ jsx(
      Primitive.div,
      {
        ref,
        className: classNames(
          className,
          footerStyle({
            orientation
          })
        ),
        ...props
      }
    );
  }
);

export { Footer };
//# sourceMappingURL=Footer.mjs.map
